/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from "react";
import {
  TextField,
  Button,
  Typography,
  Box,
  Stack,
  Checkbox,
  DialogContent,
  IconButton,
  Dialog,
  Alert,
  Snackbar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PolicyPage from "../../Pages/Policies/PolicyPage";
import TermsOfServices from "../Policies/TermsOfServices";
import { api, post } from "../../utils/api";
import CircularProgress from "@mui/material/CircularProgress";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/AuthContext";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { encryptData, encryptDataFun } from "../../utils/storage";
import axios from "axios";

const VerifyOtpPage = ({ email, password, terms, onBack, sessionId }) => {
  const navigate = useNavigate();
  const { setUser, setModule } = useUser();
  const [otp, setOtp] = useState(Array(4).fill(""));
  const inputsRef = useRef(Array(4).fill(null));
  const lastAutoSubmittedOtpRef = useRef("");
  const [isChecked, setIsChecked] = useState(false);
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  console.log("first12", terms);

  const [activeDialog, setActiveDialog] = useState(null);
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(false);
  const [ip, setIP] = useState("");

  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(interval); // Cleanup
    } else {
      setCanResend(true);
    }
  }, [timer]);

  useEffect(() => {
    const fullOtp = otp.join("");
    const isCompleteOtp = /^\d{4}$/.test(fullOtp);
    const canAutoVerify = terms || isChecked;

    if (!isCompleteOtp) {
      lastAutoSubmittedOtpRef.current = "";
      return;
    }

    if (
      canAutoVerify &&
      !loading &&
      !verified &&
      lastAutoSubmittedOtpRef.current !== fullOtp
    ) {
      lastAutoSubmittedOtpRef.current = fullOtp;
      handleVerifyOtp();
    }
  }, [otp, isChecked, terms, loading, verified]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  const handleCloseDialog = () => {
    setActiveDialog(null);
  };

  const handleChange = (index, value) => {
    if (/^\d*$/.test(value)) {
      // Allow only numbers
      const newOtp = [...otp];
      newOtp[index] = value.slice(-1); // Take only last character
      setOtp(newOtp);

      // Auto-focus to next input
      if (value && index < 3) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Enter") {
      if (index === otp.length - 1) {
        if (terms) {
          handleVerifyOtp();
        }
      }
      e.preventDefault();
    }
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      // Move focus to previous input on backspace
      inputsRef.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text/plain").slice(0, 4);
    if (/^\d+$/.test(pasteData)) {
      const newOtp = pasteData.padEnd(4, "").split("");
      setOtp(newOtp);
      inputsRef.current[3].focus();
    }
  };

  const handleResendOtp = async () => {
    try {
      const response = await post(`${api}/api/auth/login`, {
        email,
        password,
      });

      // Clear OTP input fields
      setOtp(Array(4).fill(""));
      setVerified(false);

      setSnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });

      // Focus on the first OTP input field after clearing
      inputsRef.current[0]?.focus();
    } catch (err) {
      setSnackOpen({
        open: true,
        message: "Failed to resend OTP. Please try again.",
        severity: "error",
      });
    }
  };
  function getCurrentPositionAsync() {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        return resolve(null); // or reject if you prefer
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            lat: position.coords.latitude,
            lon: position.coords.longitude,
          });
        },
        (error) => {
          console.warn("Geolocation error:", error.message);
          resolve(null); // Return null if error or permission denied
        }
      );
    });
  }

  async function getBrowserInfoWithLocation() {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;

    // Detect browser
    let browser = "Unknown";
    if (userAgent.includes("Edg")) {
      browser = "Edge";
    } else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
      browser = "Opera";
    } else if (userAgent.includes("Firefox")) {
      browser = "Firefox";
    } else if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
      browser = "Chrome";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      browser = "Safari";
    }

    // Detect OS
    let os = "Unknown";
    if (platform.includes("Win")) {
      os = "Windows";
    } else if (platform.includes("Mac")) {
      os = "MacOS";
    } else if (platform.includes("Linux")) {
      os = "Linux";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (/iPhone|iPad|iPod/.test(userAgent)) {
      os = "iOS";
    }

    const coordinates = await getCurrentPositionAsync();

    return {
      browser,
      os,
      userAgent,
      coordinates,
    };
  }

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => setIP(data.ip))
      .catch((err) => console.error("Failed to get IP:", err));
  }, []);

  useEffect(() => {
    // Focus first OTP input when page opens.
    inputsRef.current[0]?.focus();
  }, []);

  const handleVerifyOtp = async () => {
    const fullOtp = otp.join(""); // Convert array to string

    if (fullOtp.length !== 4) {
      setSnackOpen({
        open: true,
        message: "Please enter a valid 4-digit OTP",
        severity: "error",
      });
      return;
    }
    setLoading(true);

    try {
      const deviceInfo = await getBrowserInfoWithLocation();

      const res = await post(`/api/auth/verify/otp`, {
        sessionId,
        email,
        ip,
        otp: fullOtp,
        ...deviceInfo,
      });
      if (email !== res?.data?.user?.email) {
        setSnackOpen({
          open: true,
          message: "Invalide otp",
          severity: "error",
        });
        return;
      }
      let checkToken = res?.data?.newToken;
      if (!checkToken) {
        setSnackOpen({
          open: true,
          message: "token not mathc",
          severity: "error",
        });
      } else {
        try {
          await axios.post(`${api}/api/auth/verify/finalToken`, {
            newToken: checkToken,
            email,
          });
        } catch (err) {
          setSnackOpen({
            open: true,
            message:
              err?.response?.data?.message || "Invalid OTP. Please try again.",
            severity: "error",
          });
          return;
        }
      }

      sessionStorage.setItem("token", res?.data?.token);
      localStorage.setItem("refreshToken", res?.data?.refreshToken);
      localStorage.setItem("companyId", res?.data?.company);
      localStorage.setItem("user", encryptDataFun(res?.data?.user));
      localStorage.setItem(
        "questionareSubmitted",
        res?.data.user?.company?.questionareSubmitted
      );
      localStorage.setItem("module", res?.data?.user?.modules);
      setUser(res?.data?.user);
      setModule(res?.data?.user?.modules);
      if (
        res?.data?.initialQuestionare ||
        res?.data?.user?.companyAdmin === false
      ) {
        window.location.href = "/welcome";
      } else if (
        res?.data?.initialQuestionare === false &&
        res?.data?.user?.companyAdmin === true
      ) {
        window.location.href = "/company-information";
      }
      setSnackOpen({
        open: true,
        message: res.data.message,
        severity: "success",
      });
      setVerified(true);
    } catch (err) {
      console.log("first", err);
      setSnackOpen({
        open: true,
        message:
          err?.response?.data?.message || "Invalid OTP. Please try again.",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div style={{ marginBottom: "2rem" }}>
        <IconButton
          onClick={onBack}
          sx={{
            position: "absolute",
            top: "20px",
            left: "20px",
            color: "#000",
            backgroundColor: "#EB7E0E",
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            "&:hover": {
              backgroundColor: "#EB7E0E",
            },
          }}
        >
          <ArrowBackIcon fontSize="small" sx={{ color: "#fff" }} />
        </IconButton>
      </div>

      <p className="main-heading">Verify OTP</p>
      <p className="subheading">Please Use your Registered Email</p>

      {/* OTP Input Boxes */}
      <p className="input-label">Enter OTP</p>
      <Stack direction="row" spacing={2} justifyContent="center" sx={{ mb: 1 }}>
        {otp.map((digit, index) => (
          <TextField
            key={index}
            inputRef={(el) => (inputsRef.current[index] = el)}
            value={digit}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={handlePaste}
            variant="outlined"
            inputProps={{
              maxLength: 1,
              style: {
                textAlign: "center",
                fontSize: "24px",
                padding: "10px",
                width: "100%",
                height: "33px",
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                "& fieldset": {
                  borderColor: "#C4C4C4",
                },
                "&:hover fieldset": {
                  borderColor: "#C4C4C4",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#C4C4C4",
                },
              },
            }}
          />
        ))}
      </Stack>

      {!canResend && (
        <p style={{ color: "gray", fontSize: "14px", textAlign: "right" }}>
          Resend in {formatTime(timer)}
        </p>
      )}

      {/* Forgot Password */}
      <Box
        sx={{
          display: "flex",
          alignItems: "right",
          justifyContent: "right",
        }}
      >
        <p className="last-label">Didn't get the code?</p>
        <p
          className="last-label-bold"
          onClick={handleResendOtp}
          style={{
            cursor: canResend ? "pointer" : "not-allowed",
            color: canResend ? "#eb7e0e" : "gray",
          }}
        >
          Resend OTP
        </p>
      </Box>

      {!terms && (
        <Box className="privacy-container">
          <Checkbox
            checked={isChecked}
            onChange={() => setIsChecked(!isChecked)}
            sx={{ marginLeft: "-0.7rem" }}
          />
          <Typography className="privacy-text">
            Accept{" "}
            <span
              className="privacy-link"
              onClick={(e) => {
                e.preventDefault();
                // setIsPolicyOpen(true);
                setActiveDialog("policy");
              }}
            >
              Privacy Policy
            </span>
            <span
              style={{
                color: "rgba(226, 226, 226, 1)",
              }}
            >
              {" "}
              |{" "}
            </span>{" "}
            <span
              className="privacy-link"
              onClick={(e) => {
                e.preventDefault();
                // setIsTermsOpen(true);
                setActiveDialog("terms");
              }}
            >
              Terms of Service
            </span>
          </Typography>
        </Box>
      )}

      <Button
        fullWidth
        variant="contained"
        sx={{
          bgcolor: verified ? "green" : "#EB7E0E",
          color: "#fff",
          textTransform: "none",
          py: 1.2,
          borderRadius: "10px",
          "&:hover": {
            bgcolor: verified ? "green" : "#EB7E0E",
          },
        }}
        // disabled={loading || !isChecked}
        disabled={loading || (!isChecked && !terms)}
        onClick={handleVerifyOtp}
      >
        {loading ? (
          <CircularProgress size={24} sx={{ color: "white" }} />
        ) : verified ? (
          <>
            <CheckCircle sx={{ fontSize: 20, marginRight: 1 }} /> OTP Verified
          </>
        ) : (
          "Verify"
        )}
      </Button>

      <Snackbar
        open={snackOpen.open}
        message={snackOpen.message}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setSnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>

      <Dialog
        key={activeDialog}
        open={Boolean(activeDialog)}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
        BackdropProps={{
          style: {
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            backdropFilter: "blur(4px)",
            WebkitBackdropFilter: "blur(4px)",
          },
        }}
        PaperProps={{
          sx: {
            backgroundColor: "transparent",
            boxShadow: "none",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleCloseDialog}
          sx={{
            position: "absolute",
            right: "1rem",
            top: "1rem",
            zIndex: 9999,
            color: (theme) => theme.palette.grey[500],
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: "blur(2px)",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.9)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent
          sx={{
            p: 0,
            overflow: "hidden",
            height: "auto",
          }}
        >
          {activeDialog === "policy" && <PolicyPage />}
          {activeDialog === "terms" && <TermsOfServices />}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default VerifyOtpPage;
